import axios from "axios";
import { useState } from "react";

export default function TestFilters({ filters, setFilters }) {

const API_BASE = "https://api.ilogically.com/api";
const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";


function update(e){

  setFilters({
    ...filters,
    [e.target.name]: e.target.value,
    offset:0
  });

}


function selectTopic(topic){

  setFilters({
    ...filters,
    topic_name: topic,
    offset:0
  });

  setQuery(topic);
  setTopics([]);

}



function clearFilters(){

  setFilters({
    testName:"",
    difficultyLevel:"",
    testLanguage:"",
    testStatus:"",
    topic_name:"",
    sectionName:"",
    limit:20,
    offset:0
  });

  setQuery("");
  setTopics([]);

}



const [query,setQuery] = useState("");
const [topics,setTopics] = useState([]);

async function searchTopics(value){

  setQuery(value);

  if(!value){
    setTopics([]);
    return;
  }

  try{

    const res = await axios.get(
      `${API_BASE}/tests/topics`,
      {
        params:{
          search:value,
          appToken:APP_TOKEN
        }
      }
    );

    setTopics(res.data.items || []);

  }catch(err){
    console.error(err);
  }

}



return (

<div className="filtersBar">

  {/* Search Test */}

  <input  style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
    name="testName"
    placeholder="Search Test..."
    value={filters.testName}
    onChange={update}
  />


  {/* Topic Autocomplete */}

  <div className="topicBox">

    <input style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
      placeholder="Search Topic"
      value={query}
      onChange={(e)=>searchTopics(e.target.value)}
    />

    {topics.length > 0 && (

      <ul className="topicDropdown" style={{color:"#222222",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer"}}>

        {topics.map((t,i)=>(

          <li
            key={i}
            onClick={()=>selectTopic(t)}
          >
            {t}
          </li>

        ))}

      </ul>

    )}

  </div>


  {/* Section */}

  <input style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",}}
    name="sectionName"
    placeholder="Section"
    value={filters.sectionName}
    onChange={update}
  />


  {/* Difficulty */}

  <select style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",}}
    name="difficultyLevel"
    value={filters.difficultyLevel}
    onChange={update}
  >
    <option value="">Difficulty</option>
    <option value="Basic">Basic</option>
    <option value="Medium">Medium</option>
    <option value="Difficult">Difficult</option>
  </select>


  {/* Language */}

  <select style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
    name="testLanguage"
    value={filters.testLanguage}
    onChange={update}
  >
    <option value="">Language</option>
    <option value="English">English</option>
    <option value="Hindi">Hindi</option>
  </select>


  {/* Clear */}

  <button style={{fontSize:"15px",color:"#ffffff",background:"rgb(235, 121, 121)"
          ,borderRadius:"5px",cursor:"pointer",height:"35px"}}
    className="clearBtn"
    onClick={clearFilters}
  >
    Clear
  </button>



<style>{`

.filtersBar{
display:grid;
grid-template-columns:1.5fr 1.5fr 1fr 1fr 1fr auto;
gap:10px;
align-items:center;
}

.filtersBar input,
.filtersBar select{
padding:8px 10px;
border:1px solid #d1d5db;
border-radius:6px;
font-size:14px;
outline:none;
}

.filtersBar input:focus,
.filtersBar select:focus{
border-color:#2563eb;
box-shadow:0 0 0 2px rgba(37,99,235,0.15);
}

.topicBox{
position:relative;
}

.topicDropdown{
position:absolute;
top:100%;
left:0;
right:0;
background:white;
border:1px solid #e5e7eb;
border-radius:6px;
margin-top:4px;
max-height:200px;
overflow:auto;
box-shadow:0 6px 20px rgba(0,0,0,0.1);
list-style:none;
padding:0;
z-index:10;
}

.topicDropdown li{
padding:8px 12px;
cursor:pointer;
}

.topicDropdown li:hover{
background:#f3f4f6;
}

.clearBtn{
background:#ef4444;
color:white;
border:none;
padding:8px 14px;
border-radius:6px;
cursor:pointer;
}

.clearBtn:hover{
background:#dc2626;
}

`}</style>

</div>

);

}